import { combineReducers } from 'redux';
import { files, FilesState } from './files.reducer';
import { FilesMetadataState, metadata } from './metadata.reducer';
import { FilesProgressState, uploading } from './uploading.reducer';

export interface FilesRootState {
  files: FilesState;
  uploading: FilesProgressState;
  metadata: FilesMetadataState;
}

export const filesRootReducer = combineReducers<FilesRootState>({
  files,
  uploading,
  metadata,
});
